/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_PrefixInputs */

const en_reference_field_prefix = /** @type {(inputs: Reference_Field_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefix`)
};

/**
* | output |
* | --- |
* | "Prefix" |
*
* @param {Reference_Field_PrefixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_prefix = /** @type {((inputs?: Reference_Field_PrefixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_PrefixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_prefix(inputs)
});